<template>
    <div>
        <div>
            当前剩余: <span v-if="login_user_coin_count.gold_count>0" class="label label-sm label-warning">金币</span>
            <span v-if="login_user_coin_count.gold_count>0" class="margin-right-10">{{login_user_coin_count.gold_count.toFixed(2)}}</span>
            <span v-if="login_user_coin_count.silver_count>0" class="label label-sm label-default">银币</span>
            <span v-if="login_user_coin_count.silver_count>0" class="margin-right-10">{{login_user_coin_count.silver_count.toFixed(1)}}</span>
            <span v-if="login_user_coin_count.copper_count>0" class="label label-sm label-success">铜币</span>
            <span v-if="login_user_coin_count.copper_count>0" class="margin-right-10">{{login_user_coin_count.copper_count.toFixed(0)}}</span>
            <!--当前剩余 {{login_user_coin_count.gold_count.toFixed(2)}}金币 {{login_user_coin_count.silver_count}}银币 {{login_user_coin_count.copper_count}}铜币-->
        </div>
        <div v-if="user_all_copper_count<expense_all_copper_count" style="color: red;margin-top: 10px">余额不足，请先充值！</div>
        <div v-else>
            <div class="margin-top-10">需要花费:
                <span v-if="need_count.gold_count>0" class="label label-sm label-warning">金币</span>
                <span v-if="need_count.gold_count>0" class="margin-right-10">{{need_count.gold_count.toFixed(2)}}</span>
                <span v-if="need_count.silver_count>0" class="label label-sm label-default">银币</span>
                <span v-if="need_count.silver_count>0"
                      class="margin-right-10">{{need_count.silver_count.toFixed(1)}}</span>
                <span v-if="need_count.copper_count>0" class="label label-sm label-success">铜币</span>
                <span v-if="need_count.copper_count>0"
                      class="margin-right-10">{{need_count.copper_count.toFixed(0)}}</span></div>
            <!--<div>需要花费 {{need_count.gold_count}}金币 {{need_count.silver_count}}银币 {{need_count.copper_count}}铜币</div>-->
            <div class="margin-top-10">购买后剩余:
                <span v-if="login_user_coin_count.gold_count - need_count.gold_count>0"
                      class="label label-sm label-warning">金币</span>
                <span v-if="login_user_coin_count.gold_count - need_count.gold_count>0" class="margin-right-10">{{(login_user_coin_count.gold_count - need_count.gold_count).toFixed(2)}}</span>
                <span v-if="login_user_coin_count.silver_count - need_count.silver_count>0"
                      class="label label-sm label-default">银币</span>
                <span v-if="login_user_coin_count.silver_count - need_count.silver_count>0"
                      class="margin-right-10">{{(login_user_coin_count.silver_count - need_count.silver_count).toFixed(1)}}</span>
                <span v-if="login_user_coin_count.copper_count - need_count.copper_count>0"
                      class="label label-sm label-success">铜币</span>
                <span v-if="login_user_coin_count.copper_count - need_count.copper_count>0"
                      class="margin-right-10">{{(login_user_coin_count.copper_count - need_count.copper_count).toFixed(0)}}</span>
            </div>
            <!--<div>购买后剩余: {{(login_user_coin_count.gold_count - need_count.gold_count).toFixed(2)}}金币 {{login_user_coin_count.silver_count - -->
            <!--need_count.silver_count}}银币 {{login_user_coin_count.copper_count - need_count.copper_count}}铜币-->
            <!--</div>-->
        </div>
        <div class="footer" style="margin-top: 20px;overflow: hidden">
            <div v-if="type==='ujoyer.course.course' || type==='ir.attachment'" style="font-size: 27px;float: left">
                购买：{{data.name}}
            </div>
            <div v-if="type==='ujoyer.plus'" style="font-size: 27px;float: left">购买：{{data.title}}</div>
            <el-button style="float: right" type="primary"
                       @click="confirm_buy(data,user_all_copper_count,expense_all_copper_count,need_count)"
                       :disabled="user_all_copper_count<expense_all_copper_count">确 定
            </el-button>
        </div>
    </div>
</template>
<script type="text/javascript">
    import accountApi from '@/api/account/account.js'
    import {mapState, mapActions} from 'vuex'

    export default {
        props: {
            data: {
                type: Object,
                require: true
            },
            type: {},
            user_item_id: {},
            // need_count: {
            //     type: Object,
            //     require: true
            // },
            all_need_count: {},
            // login_user_coin_count: {
            //     type: Object,
            //     require: true
            // },
            no_reload: {},
        },
        data: function () {
            return {
                need_count: {},
                login_user_coin_count: {},
            }
        },
        components: {},
        computed: {
            ...mapState({}),
            user_all_copper_count: function () {
                return this.login_user_coin_count.gold_count * 100 + this.login_user_coin_count.silver_count * 10 + this.login_user_coin_count.copper_count
            },
            expense_all_copper_count: function () {
                return this.data.price * 100
            },

        },
        methods: {
            ...mapActions({}),
            get_need_count: function () {
                let need_count = {
                    'gold_count': 0,
                    'silver_count': 0,
                    'copper_count': 0,
                }
                let all_need_count = this.all_need_count
                let user_copper_count = this.login_user_coin_count.copper_count
                if (user_copper_count <= all_need_count) {
                    need_count.copper_count = user_copper_count
                } else {
                    need_count.copper_count = all_need_count
                    return need_count
                }
                all_need_count -= need_count.copper_count

                let user_silver_count = this.login_user_coin_count.silver_count
                if (user_silver_count * 10 <= all_need_count) {
                    need_count.silver_count = user_silver_count
                } else {
                    need_count.silver_count = all_need_count / 10
                    return need_count
                }
                all_need_count -= need_count.silver_count * 10

                let user_gold_count = this.login_user_coin_count.gold_count
                if (user_gold_count * 100 <= all_need_count) {
                    need_count.gold_count = user_gold_count
                } else {
                    need_count.gold_count = all_need_count / 100
                    return need_count
                }
                all_need_count -= need_count.gold_count * 100
                return need_count
            },
            confirm_buy(item_info, user_all_copper_count, expense_all_copper_count, need_count) {
                let args = {
                    'type': this.type,
                    'expense_item_id': item_info.id,
                    'quantity': 1,
                    'price': item_info.price,
                    'state': 'process',
                    'user_all_copper_count': user_all_copper_count,
                    'expense_all_copper_count': expense_all_copper_count,
                    'need_count': need_count,
                    'user_item_id': this.user_item_id,
                }
                accountApi.create_expense_record(args).then((res) => {
                    console.log(res)
                    let data = JSON.parse(res.data.result);
                    if (data.code == 'success') {
                        this.$message({
                            message: data.message,
                            type: 'success'
                        });
                        if (!this.no_reload){
                            setTimeout(function () {
                                location.reload();
                            }, 2000);
                        }else{
                            console.log('exp message_back')
                            this.$emit('message_back')
                        }
                    } else {
                        this.$message({
                            message: data.message,
                            type: 'warning'
                        });
                    }
                })
            },
        },
        mounted() {
            accountApi.get_login_user_coin_count().then((res) => {
                this.login_user_coin_count = res.data
                this.need_count = this.get_need_count()
            })
        }
    }
</script>
<style type="text/css" scoped>
</style>